import { styled } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
`;

export const Line = styled.div<{ color: string }>`
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: ${({ color }) => color};
`;

export const LoaderWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
